import { collection, doc, setDoc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from '../../config/firebase';
import { COLLECTIONS } from './schema';
import { UserProfile } from '../../types/user';

export const createUserProfile = async (
  userId: string,
  email: string,
  name: string
): Promise<void> => {
  const userRef = doc(db, COLLECTIONS.USERS, userId);
  const userProfile: UserProfile = {
    id: userId,
    email,
    name,
    role: email === import.meta.env.VITE_ADMIN_EMAIL ? 'admin' : 'user',
    createdAt: new Date()
  };
  await setDoc(userRef, userProfile);
};

export const getUserProfile = async (userId: string): Promise<UserProfile | null> => {
  const userRef = doc(db, COLLECTIONS.USERS, userId);
  const userDoc = await getDoc(userRef);
  return userDoc.exists() ? userDoc.data() as UserProfile : null;
};

export const updateUserProfile = async (
  userId: string,
  updates: Partial<UserProfile>
): Promise<void> => {
  const userRef = doc(db, COLLECTIONS.USERS, userId);
  await updateDoc(userRef, updates);
};